// SEO metadata per route. Source of truth: MyDrAI_SEO_Master.doc.pdf §4.
// Descriptions are hand-written from the Primary H1 + doc positioning so the
// SERP snippet matches the on-page hero and doesn't get truncated (kept to
// ~155 chars where possible).

export const SITE_URL = 'https://mydrai.co';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/fullLogo.png`;

const SEO_MAP = {
  '/': {
    title: 'Medical Weight Loss & Health Platform Malaysia | MyDr.Ai',
    description:
      "MyDr.Ai — Malaysia's doctor-led, AI-assisted medical weight management platform. Book a licensed clinic consultation. Personalized for Malaysians.",
    keyword: 'medical weight loss malaysia',
  },
  '/weight-management': {
    title: 'Medical Weight Management Programme Malaysia | MyDr.Ai',
    description:
      "Comprehensive medical weight management in Malaysia — doctor-led, AI-assisted, science-backed care with licensed clinics across the Klang Valley.",
    keyword: 'medical weight management malaysia',
  },
  '/how-it-works': {
    title: 'How Doctor-Guided Weight Management Works | MyDr.Ai Malaysia',
    description:
      "From digital onboarding to in-person doctor-led care — see how MyDr.Ai delivers safe, AI-assisted medical weight management in Malaysia.",
    keyword: 'doctor guided weight loss malaysia',
  },
  '/clinics': {
    title: 'Panel Clinics & Doctors | Medical Weight Loss Kuala Lumpur | MyDr.Ai',
    description:
      "Licensed panel clinics and medical doctors across the Klang Valley delivering in-person MyDr.Ai medical weight management consultations.",
    keyword: 'weight loss clinic kuala lumpur',
  },
  '/about': {
    title: 'About MyDr.Ai | AI-Powered Preventive Health Platform Malaysia',
    description:
      "Pioneering AI-assisted, doctor-led healthcare in Malaysia. Learn how MyDr.Ai combines science-backed protocols with a national clinic network.",
    keyword: 'ai powered healthcare malaysia',
  },
  '/faq': {
    title: 'Frequently Asked Questions | Medical Weight Loss & Health | MyDr.Ai',
    description:
      "Answers about MyDr.Ai — eligibility, consultations with licensed doctors, treatment costs, safety, follow-ups and preventive health in Malaysia.",
    keyword: 'medical weight loss consultation malaysia',
  },
  '/testimonials': {
    title: 'Patient Experiences & Testimonials | Medical Weight Loss | MyDr.Ai',
    description:
      "Real journeys to metabolic health with MyDr.Ai — patient experiences from Malaysians on the doctor-led, AI-assisted weight management programme.",
    keyword: 'medical weight loss reviews malaysia',
  },
  '/preventive-health': {
    title: 'Preventive Health & Advanced Lab Testing Malaysia | MyDr.Ai',
    description:
      "AI-assisted preventive health and advanced biomarker testing in Malaysia. Early insight, licensed clinicians, actionable follow-up plans.",
    keyword: 'preventive health screening malaysia',
  },
  '/preventive-health/waitlist': {
    title: 'Preventive Health Waiting List Malaysia | MyDr.Ai Early Access',
    description:
      "Join the priority waiting list for MyDr.Ai Preventive Health — early access to advanced biomarker testing and doctor-led review in Malaysia.",
    keyword: 'preventive health waiting list malaysia',
  },
  '/medical-disclaimer': {
    title: 'Medical Disclaimer & Clinical Advisory Policy | MyDr.Ai',
    description:
      "MyDr.Ai medical disclaimer and clinical practice standards. Read our advisory policy on AI-assisted, doctor-led care in Malaysia.",
    keyword: 'medical disclaimer mydrai',
  },
  '/terms': {
    title: 'Terms of Use | MyDr.Ai',
    description: 'MyDr.Ai Terms of Use for patients, clinics and partners.',
    keyword: '',
  },
  '/privacy': {
    title: 'Privacy Policy | MyDr.Ai',
    description: "How MyDr.Ai handles your data under Malaysia's PDPA.",
    keyword: '',
  },
  '/privacy-policy': {
    title: 'Privacy Policy | MyDr.Ai',
    description: "How MyDr.Ai handles your data under Malaysia's PDPA.",
    keyword: '',
  },
};

// Canonical URL for any pathname — always the doc-mandated host, always
// no trailing slash (except the root).
export function canonicalFor(pathname) {
  const p = String(pathname || '/').replace(/\/+$/, '') || '/';
  return `${SITE_URL}${p === '/' ? '/' : p}`;
}

export function seoFor(pathname) {
  const p = String(pathname || '/').replace(/\/+$/, '') || '/';
  const fallback = SEO_MAP['/'];
  return SEO_MAP[p] || fallback;
}

export default SEO_MAP;
